import {
  SET_CURRENT_USER,
  SET_TABLES,
  SET_GLOBAL_CHAT,
  SET_TABLE_CHAT,
  SET_RECENT_GAMES,
  SET_CONFIG,
  SET_TOP_EARNERS,
  SET_TOP_WINNERS,
  SET_ACTIVE_USERS,
  RESET_APP,
} from "./types";

const initState = {
  currentUser: null,
  tables: [],
  globalChat: { messages: [] },
  tableChat: { messages: [] },
  recentGames: [],
  config: {},
  topEarners: [],
  topWinners: [],
  activeUsers: [],
};

const MainReducer = (state = initState, action) => {
  switch (action.type) {
    case SET_CURRENT_USER:
      return {
        ...state,
        currentUser: action.payload,
      };
    case SET_TABLES:
      return {
        ...state,
        tables: action.payload,
      };
    case SET_GLOBAL_CHAT:
      return {
        ...state,
        globalChat: action.payload,
      };
    case SET_TABLE_CHAT:
      return {
        ...state,
        tableChat: action.payload,
      };
    case SET_RECENT_GAMES:
      return {
        ...state,
        recentGames: action.payload,
      };
    case SET_CONFIG:
      return {
        ...state,
        config: action.payload,
      };
    case SET_TOP_EARNERS:
      return {
        ...state,
        topEarners: action.payload,
      };
    case SET_TOP_WINNERS:
      return {
        ...state,
        topWinners: action.payload,
      };
    case SET_ACTIVE_USERS:
      return {
        ...state,
        activeUsers: action.payload,
      };
    case RESET_APP:
      return initState;
    default:
      return state;
  }
};

export default MainReducer;
